import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const areas = [
  { name: 'London', icon: 'ri-building-2-line', tag: 'All Boroughs', href: '/#coverage' },
  { name: 'Essex', icon: 'ri-home-4-line', tag: 'Full County', href: '/#coverage' },
  { name: 'Suffolk', icon: 'ri-landscape-line', tag: 'Full County', href: '/#coverage' },
  { name: 'Cambridge', icon: 'ri-graduation-cap-line', tag: 'Cambridgeshire', href: '/#coverage' },
];

export default function CoverageStrip() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="bg-[#f7f8fa] py-10 md:py-14 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={ref}
          className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          {/* Heading */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-[#4CAF50] mb-1">COVERAGE AREAS</div>
              <h3 className="font-heading font-black text-[#1F2933] text-xl md:text-2xl">
                Serving London, Essex, Suffolk &amp; Cambridge
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                Commercial &amp; residential installations — OZEV-approved engineers in your area.
              </p>
            </div>
            <Link
              to="/#coverage"
              className="flex items-center gap-2 border-2 border-[#145A32] text-[#145A32] font-bold px-5 py-2.5 rounded-full text-sm hover:bg-[#145A32] hover:text-white transition-all cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-line text-sm" />
              </div>
              View all areas
            </Link>
          </div>

          {/* Area pills row */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {areas.map((area, i) => (
              <div
                key={area.name}
                style={{ transitionDelay: `${i * 80}ms` }}
                className={`bg-white border border-gray-100 rounded-xl p-4 flex items-center gap-3 hover:border-[#4CAF50]/40 hover:-translate-y-0.5 transition-all duration-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#145A32]/10 flex-shrink-0">
                  <i className={`${area.icon} text-[#145A32] text-base`} />
                </div>
                <div>
                  <div className="font-bold text-[#1F2933] text-sm leading-tight">{area.name}</div>
                  <div className="text-[10px] text-gray-400">{area.tag}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Commercial & Residential badges */}
          <div className="flex flex-wrap gap-3 mt-5 items-center">
            <div className="flex items-center gap-2 bg-[#145A32] text-white text-xs font-bold px-4 py-2 rounded-full">
              <div className="w-3 h-3 flex items-center justify-center"><i className="ri-building-line text-[#7AC943] text-xs" /></div>
              Commercial EV Charging
            </div>
            <div className="flex items-center gap-2 bg-white border border-[#145A32]/20 text-[#145A32] text-xs font-bold px-4 py-2 rounded-full">
              <div className="w-3 h-3 flex items-center justify-center"><i className="ri-home-line text-[#145A32] text-xs" /></div>
              Residential EV Charging
            </div>
            <div className="flex items-center gap-2 bg-white border border-gray-200 text-gray-600 text-xs font-semibold px-4 py-2 rounded-full">
              <div className="w-3 h-3 flex items-center justify-center"><i className="ri-award-line text-[#4CAF50] text-xs" /></div>
              OZEV Approved Installers
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
